import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LegalContentService, LegalSection } from './legal-content.service';

@Component({
  selector: 'landing-legal-page',
  templateUrl: './legal-page.component.html',
  styleUrls: ['./legal-page.component.scss'],
})
export class LegalPageComponent implements OnInit {
  sections: LegalSection[] = [];
  activeSection: string = '';

  constructor(private contentService: LegalContentService, private router: Router) {}

  ngOnInit(): void {
    this.sections = this.contentService.getSectionsList();
    this.setActiveFromUrl();

    // update activeSection on navigation end (keeps sidebar state in sync)
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
      this.setActiveFromUrl();
    });
  }

  navigateTo(key: string) {
    this.router.navigate(['/legal', key]);
    this.activeSection = key; // immediate visual feedback
  }

  private setActiveFromUrl() {
    const parts = (this.router.url || '').split('/');
    // expected url: /legal/{section}[/{fileSlug}]
    this.activeSection = parts.length >= 3 && parts[2] ? parts[2] : '';
  }
}
